import React from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';

class Expertise extends React.Component {
  render() {
    return <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
    Scientific Expertise & Capabilities
    </Header>
    <Divider/>
      <p>
        Through its Council of Experts and scientists from prominent research universities,
        OVC provides consultancy services to innovative science startups in connection with product
        commercialization in the US and Asia. When startups require additional growth capital, OVC can
        assist them with capital advice and introductions to strategic partners in the US and Asia. OVC has
        established sources for venture capital with both private and public institutional investors.
      </p>
    </Container>;
  }
}

export default Expertise;
